import React from 'react';
import './Spinner.css';
import { CircularProgress } from '@material-ui/core';
// import Spinner from 'react-spinner-material';

class Spin extends React.Component{
    render(){
        return(
            <div className={(this.props.noOverlay ? "m-top-spinner" : "overlay m-top-spinner")}>
                <div className="spinner">
                    {this.props.children}
                    {/* <Spinner
                        size={this.props.size || 60}
                        spinnerColor={this.props.color || "#ffc107"}
                        spinnerWidth={this.props.spinWidth || 4}
                        visible={this.props.visible || true} 
                    /> */}
                    <CircularProgress color="secondary" size={60} />
                </div>
            </div>
        )
    }
};

export default Spin;
